module.exports = __webpack_public_path__ + "static/img/qjy88.3aefb5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/qjy88.png
// module id = Y3LR
// module chunks = 0